import { Cloud, HardDrive } from "lucide-react";

interface SourcePickerProps {
  /** Called when the user chooses to browse their personal OneDrive. */
  onChooseOneDrive: () => void;
  /** Called when the user chooses to browse SharePoint sites. */
  onChooseSharePoint: () => void;
}

/**
 * First-step picker letting the user choose between browsing their personal
 * OneDrive or SharePoint sites. Rendered by `SharePointBrowser` when the
 * `allowOneDrive` prop is enabled.
 */
export function SourcePicker({ onChooseOneDrive, onChooseSharePoint }: Readonly<SourcePickerProps>) {
  return (
    <div className="p-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
      <button
        type="button"
        onClick={onChooseOneDrive}
        className="flex flex-col items-center gap-3 p-6 rounded-xl border border-border-secondary hover:border-brand-primary hover:bg-surface-secondary/50 transition-colors text-center"
      >
        <div className="h-12 w-12 rounded-xl bg-blue-500/10 flex items-center justify-center">
          <HardDrive className="h-6 w-6 text-blue-400" />
        </div>
        <div>
          <p className="text-sm font-medium text-content-primary">My OneDrive</p>
          <p className="text-xs text-content-quaternary mt-0.5">Browse your personal files</p>
        </div>
      </button>
      <button
        type="button"
        onClick={onChooseSharePoint}
        className="flex flex-col items-center gap-3 p-6 rounded-xl border border-border-secondary hover:border-brand-primary hover:bg-surface-secondary/50 transition-colors text-center"
      >
        <div className="h-12 w-12 rounded-xl bg-purple-500/10 flex items-center justify-center">
          <Cloud className="h-6 w-6 text-purple-400" />
        </div>
        <div>
          <p className="text-sm font-medium text-content-primary">SharePoint Sites</p>
          <p className="text-xs text-content-quaternary mt-0.5">Browse team &amp; communication sites</p>
        </div>
      </button>
    </div>
  );
}
